import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, Card, CardContent, CardHeader, Checkbox, Grid, IconButton } from "@mui/material";
import DemoParinted from "../../../../templates/ApplicationDetails/components/RichTextArea";
import { CheckBox, Dropdown, PrintIcon, RadioOrSelect, UploadFile } from "@egovernments/digit-ui-react-components";
import axios from "axios";
import { ScrutinyRemarksContext } from "../../../Context/remarks-data-context";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";
import { ConvertEpochToDate } from "@egovernments/digit-ui-libraries/src/services/atoms/Utils/Date";
import ChatBoardHistory from "./ChatBoardHistory";
import { Box } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { FaFilePdf } from "react-icons/fa";
import { makeStyles } from "@material-ui/core/styles";
import FormattedDate from "../TimeStamp";
import FileUploaderNew from "../../pages/citizen/AVPForms/reusableComponents/FileUploaderMuiltple";
import InspectionPhotoViewer from "../../../../templates/ApplicationDetails/components/EmpReusableComp/DocumentViewSite";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SafeHtml from "@egovernments/digit-ui-module-common/src/sharedComponents/SafeHtml";
import CloseIcon from "@mui/icons-material/Close";
import DescriptionIcon from "@mui/icons-material/Description";

const useStyles = makeStyles((theme) => ({
  p: {
    fontSize: "14px",
    overflow: "hidden",
    whitespce: "nowrap",
  },
}));

const ChatboardCorrespondence = ({ formData, assignerToChatboard }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const Modal = useModal();
  const { chatBoardDataRemarks, handleGetRemarkssValues, chatBoardHistoryData, handleGetHistoryRemarkssValues } = useContext(ScrutinyRemarksContext);
  const [content, setContent] = useState("");
  const [loader, setLoader] = useState(false);
  const [roleSet, setRoleSet] = useState([]);
  const typeOfUser = assignerToChatboard?.data?.processInstance?.assigner?.type;
  const userData = Digit.UserService.getUser() || {};
  const userInfo = userData?.info || {};
  const authToken = userData?.access_token || null;
  const userRolesArray = userInfo?.roles.filter((user) => user.code !== "EMPLOYEE");
  const assignerRolesArray = assignerToChatboard?.data?.processInstance?.assigner?.roles.filter((assigner) => assigner.code !== "EMPLOYEE");
  const filterDataRole = userRolesArray?.[0]?.code;
  const designation = userRolesArray?.[0]?.name;
  const [developerRemarks, setDeveloperRemarks] = React.useState("");
  const [messageTo, setMessageTo] = React.useState(undefined);
  const [assignTo, setAssignTo] = React.useState(undefined);
  const [applicantChecked, setApplicantChecked] = useState(false);
  const [ownerChecked, setOwnerChecked] = useState(false);
  const [developerChecked, setDeveloperChecked] = useState(false);
  const [docPopupData, setDocPopupData] = useState(null);
  const [showDocPopup, setShowDocPopup] = useState(false);
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [uploadedFileAttachment, setUploadedFileAttachment] = useState(null);
  const [error, setError] = useState(null);
  const officerRole = userInfo?.roles?.filter((item) => item.code !== "EMPLOYEE");
  const [chatBoardDocs, setChatBoardDocs] = useState([]);
  const [selectedDetails, setSelectedDetails] = useState([]);
  const [userDetails, setUserDetails] = useState(null);
  const [createdTime, setCreatedTime] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState(null);


  const openPopup = (item) => {
    debugger;
    let rows = [];
    rows = item?.documentId || [];

    setShowPopup(true);
    setSelectedDetails(rows);
    // setUserDetails(item.userDetails || {});
    setCreatedTime(item?.createdOn || null);
    setPopupData(item);

  };

  console.log("selectedDetails", selectedDetails);

  const closePopup = () => {
    setShowPopup(false);
    setSelectedDetails([]);
    // setUserDetails(null);
    setPopupData(null);
  };

  const printPopup = () => {
    const popupContent = document.getElementById("popup-print-content");
    if (!popupContent) return;

    const printWindow = window.open("", "_blank", "width=800,height=600");
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Details</title>
          <style>
            body { font-size: 11px; font-family: Arial; }
            table { width: 100%; border-collapse: collapse; }
            th, td { border: 1px solid #ccc; padding: 6px; }
            th { background-color: #e2e8f0; font-size: 13px; }
          </style>
        </head>
        <body>
          ${popupContent.innerHTML}
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };



  function selectFile(e) {
    setFile(e.target.files[0]);
  }

  const selectRole = (role, name, useruuid) => {
    setAssignTo(role, name, useruuid);
  };

  const handleUpdate = (event) => {
    const editorContent = event.target.innerHTML;
    setContent(editorContent);
  };

  const closeEditor = () => {
    setContent("");
    setDeveloperRemarks("");
  };

  const onMessageToChange = (e) => {
    if (e.target.value !== messageTo) {
      if (e.target.checked) {
        setMessageTo(e.target.value);
        if (e.target.value === "Applicant") {
          setApplicantChecked(true);
          setOwnerChecked(false);
          setDeveloperChecked(false);
        } else if (e.target.value === "Owner/Developer") {
          setApplicantChecked(false);
          setOwnerChecked(true);
          setDeveloperChecked(false);
        } else if (e.target.value === "Department") {
          setApplicantChecked(false);
          setOwnerChecked(false);
          setDeveloperChecked(true);
        }
      }
    }
  };

  const handlemodalsubmit = async () => {
    setLoader(true);
    const postData = {
      requestInfo: {
        api_id: "1",
        ver: "1",
        ts: null,
        action: "create",
        did: "",
        key: "",
        msg_id: "",
        requester_id: "",
        authToken: authToken,
      },
      egScrutiny: {
        applicationId: formData?.applicationNo,
        comment: developerRemarks,
        fieldValue: messageTo ? true : false,
        fieldIdL: messageTo ? messageTo : "",
        isApproved: "CHAT_BOARD",
        isLOIPart: false, //Message To
        userid: userInfo?.id || null,
        serviceId: 0,
        documentId: chatBoardDocs, //document attachment
        bussinessServiceName: formData?.businessService,
        designation: designation,
        name: userInfo?.type || null,
        employeeName: userInfo?.name || null,
        role: filterDataRole,
        applicationStatus: formData?.status,
        assignTo: assignTo || null,
        chatBoardStatus: "PENDING" || null,
        chatBoardReply: {},
        previousStatus: "",
        previousUserId: 0,
        previousEmployeeRole: "",
      },
    };

    try {
      const Resp = await axios.post("/land-services/egscrutiny/_create?status=submit", postData, {}).then((response) => {
        return response.data;
      });
      setLoader(false);
    } catch (error) {
      console.log(error);
    }

    let redirectPath = "";

    if (formData?.applicationType === "FORM_MAP") {
      redirectPath = `/digit-ui/employee/obps/application/MAP_SUB/${formData?.applicationNo}`;
    } else if (formData?.applicationType === "FORM_PURCHASABLE_FAR") {
      redirectPath = `/digit-ui/employee/obps/application/PURCHASABLE_FAR/${formData?.applicationNo}`;
    } else {
      redirectPath = `/digit-ui/employee/obps/application/formLandUse/${formData?.applicationNo}`;
    }

    Modal("Application Chat Board", `Application <strong>(${formData?.applicationNo}) Chat Board</strong> Successfully!`, "success", redirectPath);
    await handleGetRemarkssValues(formData?.applicationNo), handleGetHistoryRemarkssValues(formData?.applicationNo);
  };
  const handlemodalAttachment = (e) => {
    setUploadedFileAttachment("AttachmentOPen");
  };
  const [post, setPost] = useState({
    // title: '',
    content: "",
    hearingDate: "",
    // categoryId: ''
  });

  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        const allowedFileTypesRegex = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
        if (file.size >= 5242880) {
          setError(t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else if (file?.type && !allowedFileTypesRegex.test(file?.type)) {
          setError(t(`NOT_SUPPORTED_FILE_TYPE`));
        } else {
          try {
            const response = await Digit.UploadServices.Filestorage("OBPS", file, Digit.ULBService.getStateId() || tenantId?.split(".")[0]);
            if (response?.data?.files?.length > 0) {
              setUploadedFile(response?.data?.files[0]?.fileStoreId);
            } else {
              setError(t("CS_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            setError(t("CS_FILE_UPLOAD_ERROR"));
          }
        }
      }
    })();
  }, [file]);

  useEffect(() => {
    assignerToChatboard?.forEach((e) => {
      if (e?.assigner?.type !== "CITIZEN") {
        e?.assigner?.roles?.forEach((role) => {
          if (role?.code !== "EMPLOYEE" && role?.code !== officerRole?.[0]?.code) {
            const ind = roleSet.findIndex((r) => r.name == role.name && r.code == role.code);
            if (ind === -1) {
              roleSet.push({ name: role.name, code: role.code, useruuid: e?.assigner?.uuid });
            }
          }
        });
      }
    });
    setRoleSet(roleSet);
  }, [assignerToChatboard]);

  useEffect(() => {
    if (formData?.applicationNo) {
      handleGetRemarkssValues(formData?.applicationNo);
      handleGetHistoryRemarkssValues(formData?.applicationNo);
    }
  }, [formData?.applicationNo]);

  useEffect(() => {
    const fetchRemarks = async () => {
      if (!formData?.applicationNo) return;

      try {
        await handleGetRemarkssValues(formData?.applicationNo);
        await handleGetHistoryRemarkssValues(formData?.applicationNo);
      } catch (error) {
        console.error("Error fetching remarks:", error);
      }
    };

    fetchRemarks();
  }, [formData?.applicationNo]);

  console.log("chatBoardHistoryData", chatBoardHistoryData?.egScrutinyData, formData?.applicationNo, chatBoardDataRemarks);

  const openPopupDocument = (filteredDocuments) => {
    setDocPopupData(filteredDocuments);
    setShowDocPopup(true);
  };

  return (
    <div>
      <Card style={{ boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)" }}>
        <h2
          style={{ background: "linear-gradient(to right, #1E73BE, #E3F2FD)", padding: "10px", color: "#fff", fontWeight: "bold", textAlign: "left" }}
        >
          Application Details
        </h2>
        <Grid container spacing={1}>
          <Grid style={{ backgroundColor: "#E6EFF8", fontSize: "13px", paddingLeft: "20px" }} item xs={6} md={3}>
            <strong>File Number:</strong>
          </Grid>
          <Grid style={{ backgroundColor: "#FFFFFF", fontSize: "13px" }} item xs={6} md={3}>
            {formData?.applicationNo}
          </Grid>
          <Grid style={{ backgroundColor: "#E6EFF8", fontSize: "13px" }} item xs={6} md={3}>
            <strong>Submitted On:</strong>
          </Grid>
          <Grid style={{ backgroundColor: "#FFFFFF", fontSize: "13px" }} item xs={6} md={3}>
            {ConvertEpochToDate(formData?.auditDetails?.createdTime)}
          </Grid>
          <Grid style={{ backgroundColor: "#E6EFF8", fontSize: "13px", paddingLeft: "20px" }} item xs={6} md={3}>
            <strong>Name of Owner/Applicant:</strong>
          </Grid>
          <Grid style={{ backgroundColor: "#FFFFFF", fontSize: "13px" }} item xs={6} md={3}>
            {formData?.landInfo?.owners?.[0]?.name}
          </Grid>
          <Grid style={{ backgroundColor: "#E6EFF8", fontSize: "13px" }} item xs={6} md={3}>
            <strong>Name of Architect:</strong>
          </Grid>
          <Grid style={{ backgroundColor: "#FFFFFF", fontSize: "13px" }} item xs={6} md={3}>
            {formData?.professionalInformation?.name}
          </Grid>
          <Grid style={{ backgroundColor: "#E6EFF8", fontSize: "13px", paddingLeft: "20px" }} item xs={6} md={3}>
            <strong>Project Type:</strong>
          </Grid>
          <Grid style={{ backgroundColor: "#FFFFF", fontSize: "13px" }} item xs={6} md={3}>
            {formData?.applicationType}
          </Grid>
        </Grid>
      </Card>

      <Card style={{ marginTop: "1rem" }}>
        <Grid container spacing={1}>
          <Grid style={{ backgroundColor: "#E6EFF8", paddingLeft: "20px", paddingTop: "1rem" }} item xs={6} md={3}>
            <strong>Message To</strong>
          </Grid>
          {/* <Grid style={{backgroundColor:'white'}} item xs={6} md={6}> */}
          <Grid style={{ fontSize: "14px", marginTop: "8px", marginBottom: "-8px" }} item xs={6} md={3}>
            <CheckBox
              className="form-field"
              label={`Applicant`}
              onChange={onMessageToChange}
              checked={applicantChecked}
              style={{ marginLeft: "30px", paddingTop: "3px", fontSize: "14px" }}
            />
          </Grid>
          {/* <Grid style={{fontSize:"14px"}} item xs={6} md={3}>
       <CheckBox
              disable={true}
              className="form-field"
              label={`Owner/Developer`}
              onChange={onMessageToChange}
              checked={ownerChecked}
              style={{ marginLeft: "25px",paddingTop:'5px',fontSize:"14px" }}
            />  
       </Grid> */}
          <Grid style={{ fontSize: "14px", marginTop: "8px", marginBottom: "-8px" }} item xs={6} md={3}>
            <CheckBox
              className="form-field"
              label={`Department`}
              onChange={onMessageToChange}
              checked={developerChecked}
              style={{ marginLeft: "30px", paddingTop: "3px", fontSize: "14px" }}
            />
          </Grid>
          {/* </Grid> */}
        </Grid>
      </Card>
      {developerChecked === true && typeOfUser !== "CITIZEN" && (
        <Card style={{ marginTop: "1rem", overflow: "visible" }}>
          <Grid container spacing={1}>
            <Grid style={{ backgroundColor: "#E6EFF8", paddingLeft: "20px", paddingTop: "1rem" }} item xs={6} md={3}>
              <strong>Assign To</strong>
            </Grid>
            {/* <Grid style={{backgroundColor:'white'}} item xs={6} md={6}> */}
            <Grid style={{ fontSize: "14px", marginTop: "8px", marginBottom: "-8px" }} item xs={6} md={3}>
              <Dropdown
                option={roleSet}
                optionKey="name"
                optionValue="code"
                select={selectRole}
                placeholder={"Select Role"}
                style={{ marginLeft: "25px", paddingTop: "5px", fontSize: "14px", overflow: "visible" }}
              />
            </Grid>
          </Grid>
        </Card>
      )}

      <Card style={{ marginTop: "1rem", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)" }}>
        <DemoParinted id="joditeditor" setContent={setDeveloperRemarks} content={developerRemarks}></DemoParinted>

        {uploadedFileAttachment === "AttachmentOPen" && (
          <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
            <Box gridColumn="span 3"> Document /Certificate</Box>
            <Box gridColumn="span 9">
              {/* <UploadFile
                  id={"workflow-doc"}
                  onUpload={selectFile}
                  onDelete={() => {
                    setUploadedFile(null);
                  }}
                  message={uploadedFile ? `1 ${t(`ES_PT_ACTION_FILEUPLOADED`)}` : t(`CS_ACTION_NO_FILEUPLOADED`)}
                  accept="image/*, .pdf, .png, .jpeg, .jpg"
                  iserror={error}
                /> */}
              <FileUploaderNew
                // isMandatory
                // label="Upload Document"
                // control={control}
                // name="siteInspectionDocument"
                validationMsg="(jpg, jpeg, pdf, png file only and Max file Size 30 MB)"
                // required
                tab={2}
                maxFiles={5}
                uploadedDocs={chatBoardDocs}
                setUploadedDocs={setChatBoardDocs}
              />
            </Box>
          </Box>
        )}

        <Button
          className="submit-bar submit-bar-take-action"
          style={{ marginLeft: 20, color: "#fff", textAlign: "center", marginBottom: "5px" }}
          onClick={handlemodalsubmit}
        >
          Send
        </Button>
        <Button
          className="submit-bar submit-bar-take-action"
          style={{ marginLeft: "10px", color: "#fff", textAlign: "center", marginBottom: "5px" }}
          onClick={closeEditor}
        >
          Cancel
        </Button>
        <Button
          className="submit-bar submit-bar-take-action"
          style={{ marginLeft: "70px", color: "#fff", textAlign: "center", marginBottom: "5px" }}
          onClick={handlemodalAttachment}
        >
          Attachment
        </Button>
      </Card>
      {/* {formData && chatBoardHistoryData &&(
          <Card style={{marginTop:'1rem',boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",backgroundColor:'#E6EFF8'}}>
                  <h2 style={{ background: "linear-gradient(to right, #1E73BE, #E3F2FD)", padding: "10px", color: "#fff", fontWeight: "bold", textAlign: "left" }}>History Of Web Message</h2>
                     {chatBoardHistoryData?.egScrutiny?.map((item, index) => (
                                <div style={{width:'100%'}}>
                                 <Card style={{float:item?.userid == userInfo?.id?'right':'left',width:'50%',boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",marginRight:"5px",padding:'5px'}}>
                                 <p className={classes.p}>AssignTo:{item?.assignTo?.name},{item?.assignTo?.code}</p>
                                      <p className={classes.p}>Message:{<div dangerouslySetInnerHTML={{__html: item?.comment}}/>}</p>
                                      <p className={classes.p}>File:{item?.applicationId}</p>
                                      <p className={classes.p}>Chat Board :{item?.chatBoardStatus}</p>
                                      <p className={classes.p}>Created By:{item?.employeeName},({item?.designation})</p>
                                    
                                      <p className={classes.p}>Date:{ConvertEpochToDate(item?.createdOn)}</p>
                                      <p className={classes.p}>Attachments:{item?.documentId}</p>
                                      
                                 </Card>
                                 <br></br><br></br>
                                </div>
                                )
                               )}
            </Card>

) } */}
      {showPopup && (
        <div
          style={{
            position: "fixed",
            top: "15%",
            left: "60%",
            transform: "translateX(-50%)",
            backgroundColor: "#f3f4f6",
            border: "1px solid #ccc",
            padding: "20px",
            zIndex: 1000,
            maxHeight: "80vh",
            overflowY: "auto",
            width: "75%",
            // maxWidth: "800px",
            boxShadow: "0 0 10px rgba(0,0,0,0.3)",
            fontSize: "11px",
          }}
        >


          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h3 style={{ fontSize: "14px" }}>
              Document Details
            </h3>
            <div>
              <IconButton onClick={printPopup} title="Print">
                <PrintIcon />
              </IconButton>
              <IconButton onClick={closePopup} title="Close">
                <CloseIcon />
              </IconButton>
            </div>
          </div>

          <div id="popup-print-content">

            <div style={{ marginBottom: "10px" }}>
              <strong>User:</strong> {popupData?.employeeName || "-"} |{" "}
              <strong>Designation:</strong> {popupData?.designation || "-"} |{" "}
              <strong>Role:</strong> {popupData?.role || "-"} |{" "}
              {/* <strong>Created At:</strong> {formatDate(createdTime)}  */}
              <strong>Created At:</strong> <FormattedDate timestamp={createdTime} />
            </div>
            <table
              border="1"
              cellPadding="6"
              width="100%"
              style={{ borderCollapse: "collapse", fontSize: "11px" }}
            >
              <thead style={{ backgroundColor: "#e2e8f0" }}>

                <tr>

                  <th>Document Type</th>
                  <th>File Name</th>

                </tr>

              </thead>
              <tbody>
                {selectedDetails?.map((row, i) => (
                  <tr key={i}>
                    <React.Fragment>
                      <td>{row?.documentType}</td>
                      <td>
                        {row?.documentUrl && (
                          <IconButton
                            href={row.documentUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            size="small"
                            style={{ marginLeft: 8 }}
                            title="Open Document"
                          >
                            <DescriptionIcon fontSize="small" />
                          </IconButton>
                        )}
                      </td>
                    </React.Fragment>
                  </tr>
                ))}

              </tbody>

            </table>

            {/* {formData && chatBoardHistoryData?.egScrutiny && (
        <Card style={{ marginTop: "1rem", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)" }}>
          <h2
            style={{
              background: "linear-gradient(to right, #1E73BE, #E3F2FD)",
              padding: "10px",
              color: "#fff",
              fontWeight: "bold",
              textAlign: "left",
            }}
          >
            History Of Web Message
          </h2>
           <CardHeader title="History Of Web Message" titleTypographyProps={{fontSize:'16px',fontWeight:'600',color:'#FFFFFF'}} style={{backgroundColor:'#1F4A7C',padding:'10px'}}></CardHeader> 
          <section className="remarks-table">
            <table>
              <thead>
                <tr>
                  <th style={{ fontSize: "12px" }}>Sr. No</th>
                  <th style={{ fontSize: "12px" }}>AssignTo</th>
                  <th style={{ fontSize: "12px" }}>Message To</th>
                  <th style={{ fontSize: "12px" }}>Message</th>
                  <th style={{ fontSize: "12px" }}>File Number</th>
                  <th style={{ fontSize: "12px" }}>Created By</th>
                  <th style={{ fontSize: "12px" }}>Date</th>
                  <th style={{ fontSize: "12px" }}>Attachments</th>
                </tr>
              </thead>
              <tbody>
                {chatBoardHistoryData?.egScrutiny?.map((item, index) => (
                  <tr key={index}>
                    <td style={{ fontSize: "12px" }}>{index + 1}</td>
                    <td style={{ fontSize: "12px" }}> {item?.assignTo ? `${item.assignTo.name}, ${item.assignTo.code}` : `${item?.fieldIdL}`}</td>
                    <td style={{ fontSize: "12px" }}>{item?.fieldIdL}</td>
                    <td style={{ fontSize: "12px" }}>
                      <SafeHtml html={item?.comment} />
                    </td>
                    <td style={{ fontSize: "12px" }}>{item?.applicationId}</td>
                    <td style={{ fontSize: "12px" }}>
                      {item?.employeeName},({item?.designation})
                    </td>
                    <td style={{ fontSize: "12px" }}>
                      {" "}
                      <FormattedDate timestamp={item?.createdOn} />
                    </td>
                    <td style={{ fontSize: "12px" }}>
                      <IconButton onClick={() => openPopupDocument(item)} size="small">
                        <VisibilityIcon fontSize="small" />
                      </IconButton>

                      <a target="_" href={item?.documentUrl} style={{ minWidth: "80px", height: "auto", minWidth: "30px" }}>
                        <FaFilePdf color="#a10505" style={{ width: "20px", height: "30px" }} />
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </section>
        </Card>
      )} */}



          </div>
        </div>
      )}
      {formData && chatBoardHistoryData?.egScrutiny && (

        <Card style={{ marginTop: '1rem', boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)" }}>
          <h2 style={{ background: "linear-gradient(to right, #1E73BE, #E3F2FD)", padding: "10px", color: "#fff", fontWeight: "bold", textAlign: "left" }}>History Of Web Message</h2>
          {/* <CardHeader title="History Of Web Message" titleTypographyProps={{fontSize:'16px',fontWeight:'600',color:'#FFFFFF'}} style={{backgroundColor:'#1F4A7C',padding:'10px'}}></CardHeader> */}
          <section className="remarks-table">
            <table>
              <thead>
                <tr>
                  <th style={{ fontSize: '12px' }}>Sr. No</th>
                  <th style={{ fontSize: '12px' }}>AssignTo</th>
                  <th style={{ fontSize: '12px' }}>Message To</th>
                  <th style={{ fontSize: '12px' }}>Message</th>
                  <th style={{ fontSize: '12px' }}>File Number</th>
                  <th style={{ fontSize: '12px' }}>Created By</th>
                  {/* <th style={{fontSize:'12px'}}>Recipients</th> */}
                  <th style={{ fontSize: '12px' }}>Date</th>
                  <th style={{ fontSize: '12px' }}>Attachments</th>
                </tr>
              </thead>
              <tbody>
                {chatBoardHistoryData?.egScrutiny?.map((item, index) => (
                  <tr key={index}>
                    <td style={{ fontSize: '12px' }}>{index + 1}</td>
                    <td style={{ fontSize: '12px' }}> {item?.assignTo
                      ? `${item.assignTo.name}, ${item.assignTo.code}`
                      : `${item?.fieldIdL}`}</td>
                    <td style={{ fontSize: '12px' }}>{item?.fieldIdL}</td>
                    <td style={{ fontSize: '12px' }}>{<div dangerouslySetInnerHTML={{ __html: item?.comment }} />}</td>
                    <td style={{ fontSize: '12px' }}>{item?.applicationId}</td>
                    <td style={{ fontSize: '12px' }}>{item?.employeeName},({item?.designation})</td>
                    {/* <td style={{fontSize:'12px'}}></td> */}
                    <td style={{ fontSize: '12px' }}> <FormattedDate timestamp={item?.createdOn} /></td>
                    <td style={{ fontSize: '12px' }}>
                      <IconButton onClick={() => openPopup(item)} size="small">
                        <VisibilityIcon fontSize="small" />
                      </IconButton>

                    </td>
                  </tr>

                ))}
              </tbody>
            </table>
          </section>
        </Card>

      )}
      {docPopupData?.length > 0 && <InspectionPhotoViewer documentInspection={docPopupData} />}
      {/* {formData && chatBoardHistoryData &&(
 <ChatBoardHistory formData={formData} chatBoardDataRemarks={chatBoardHistoryData}/>
)} */}
    </div>
  );
};

export default ChatboardCorrespondence;
